import { connect } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import BaseFeature from "./BaseFeature";
import PropertyDropdown from "./components/PropertyDropdown";
import { Trans } from "react-i18next";
import { PULL_UP_CURRENT } from "../../../../../../utils/constantFeatures";

class PullUpCurrent extends BaseFeature {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);

        this.state = {
            ...this.state,
            showWarning: props.properties[PULL_UP_CURRENT.pullUpCurrent]?.value === "0uA",
        };
    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = { [propertyName]: value };

        this.setState(newState);
        this.props.handleChange(propertyName, v);

        if (propertyName === PULL_UP_CURRENT.pullUpCurrent) {
            this.setState({ showWarning: value === "0uA" });
        }
    }

    render() {
        const auxAp = this.props.properties[PULL_UP_CURRENT.pullUpCurrent];
        const { showWarning } = this.state;

        return (
            <>
                <Row className="align-items-center">
                    <Col sm={4} style={{ width: "100%" }}>
                        <Card className="card-feature-component" style={{ width: "100%" }}>
                            <div className="card-header-feature">{<Trans i18nKey="Pull_Up_Current_Selection" />}</div>
                            <Card.Body className="card-body-feature" style={{ paddingTop: "0.75rem" }}>
                                <PropertyDropdown
                                    property={auxAp}
                                    properties={auxAp.valueMeta.availableValues}
                                    title={auxAp.info.displayName + ` (µA)`}
                                    dropdownStyle={{ padding: "0px", display: "flex", justifyContent: "flex-end" }}
                                    titleSize={6}
                                    dropdownSize={6}
                                    handleChange={this.handleChange}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={4} style={{ minWidth: "600px"}}>
                        {showWarning && (
                            <Card style={{ width: "80%" }}>
                                <Card.Body>
                                    <div className="error-text lead">
                                        <Trans i18nKey="pull_up_current_warning" />
                                    </div>
                                </Card.Body>
                            </Card>
                        )}
                    </Col>
                </Row>
            </>
        );
    }
}

export default connect()(PullUpCurrent);
// mapStateToProps,
// mapDispatchToProps
